<div [ngClass]="{
    'report-dropdown-list': true,
    'selectable': reportDropDownList.isSelectable,
    'selected': reportDropDownList.isSelected,
    'edited': !reportDropDownList.isSaved(),
    'highlight-hover' : designService.highlightElement,
    'draw-custom-element':isCustomDrawEnable || reportDropDownList.isCustomElement()
  }"
  [style.top]="reportDropDownList.top" [style.left]="reportDropDownList.left" [style.width]="reportDropDownList.width"
  [style.height]="reportDropDownList.height" [style.zIndex]="reportDropDownList.zIndex" [style.borderColor]="reportDropDownList.borderColor" [style.borderStyle]="reportDropDownList.borderStyle" [style.borderWidth]="reportDropDownList.borderWidth"
  (click)="onClick($event)" draggable="true" (dragstart)="onDragStart($event)"
  (dragover)="onDragOver($event)" (drop)="onDrop($event)"></div>
